export default __webpack_public_path__ + "static/media/3053.271c6249.jpg";